import React, { useState } from "react";
import { Button, Stack, Text, SheetContainer, Divider } from "@bookingcom/bui-react";
import { useDSATraceabilityController } from "./useDSATraceability.controller.js";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";
export function DSATraceabilityModal(props) {
    const { a11yClose, a11yTooltip, content, shouldRender, text, title } = useDSATraceabilityController(props);
    const [active, setActive] = useState(false);
    if (!shouldRender)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { gap: 2 },
            React.createElement(Divider, { mixin: { marginBlockStart: 2, marginBlockEnd: 0 } }),
            React.createElement(Stack, { attributes: { style: { display: "inline-flex" } }, gap: 1, direction: "row", alignItems: "center", mixin: { paddingBlockEnd: 8 } },
                React.createElement(Stack.Item, null,
                    React.createElement(Text, { variant: "body_2" }, text)),
                React.createElement(Stack.Item, null,
                    React.createElement(Button, { onClick: () => setActive(true), attributes: { "aria-label": a11yTooltip }, icon: QuestionMarkCircleIcon, variant: "tertiary-neutral" })))),
        React.createElement(SheetContainer, { title: title, closeAriaLabel: a11yClose, active: active, onClose: () => setActive(false), onCloseTrigger: () => setActive(false) },
            React.createElement(Stack, null, content.map((c) => (React.createElement(Stack.Item, { key: c },
                React.createElement(Text, { variant: "body_2" }, c))))))));
}
